<template>
  <div class="add-publicity-container">
    <!-- (1) PageHeader -->
    <ds-page-header :title="$t('addCommunityPublicity.title')" :subtitle="$t('addCommunityPublicity.page.subtitle')">
      <template #extra>
        <el-button icon="el-icon-close" @click="goBack">
          {{ $t('addCommunityPublicity.back') }}
        </el-button>
        <el-button type="primary" icon="el-icon-check" @click="submitForm">
          {{ $t('addCommunityPublicity.submit') }}
        </el-button>
      </template>
    </ds-page-header>

    <!-- (2) 表单面板 -->
    <div class="ds-panel">
      <el-form ref="form" :model="formData" label-width="150px" label-position="right" class="ds-form">
        <el-row :gutter="16">
          <el-col :xs="24" :sm="12" :md="12">
            <el-form-item :label="$t('addCommunityPublicity.pubTitle')" prop="title"
              :rules="[{ required: true, message: $t('addCommunityPublicity.requiredTitle'), trigger: 'blur' }]">
              <el-input v-model="formData.title" :placeholder="$t('addCommunityPublicity.requiredTitle')" clearable>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="12">
            <el-form-item :label="$t('addCommunityPublicity.pubType')" prop="pubType"
              :rules="[{ required: true, message: $t('addCommunityPublicity.requiredType'), trigger: 'change' }]">
              <el-select v-model="formData.pubType" class="w-full"
                :placeholder="$t('addCommunityPublicity.requiredType')">
                <el-option v-for="item in pubTypes" :key="item.statusCd" :label="item.name" :value="item.statusCd">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="16">
          <el-col :span="24">
            <el-form-item :label="$t('addCommunityPublicity.headerPhoto')" prop="headerImg"
              :rules="[{ required: true, message: $t('addCommunityPublicity.requiredHeaderPhoto'), trigger: 'change' }]">
              <upload-image-url ref="uploadImage" :image-count="1" @notifyUploadCoverImage="handleImageUpload">
              </upload-image-url>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="16">
          <el-col :span="24">
            <el-form-item :label="$t('addCommunityPublicity.activityContent')" prop="context"
              :rules="[{ required: true, message: $t('addCommunityPublicity.requiredContent'), trigger: 'blur' }]">
              <rich-text-editor v-model="formData.context" :height="300"
                :placeholder="$t('addCommunityPublicity.requiredContent')">
              </rich-text-editor>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- 表单操作区 -->
        <div class="ds-form-actions">
          <el-button icon="el-icon-close" @click="goBack">
            {{ $t('addCommunityPublicity.back') }}
          </el-button>
          <el-button type="primary" icon="el-icon-check" @click="submitForm">
            {{ $t('addCommunityPublicity.submit') }}
          </el-button>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import UploadImageUrl from '@/components/upload/UploadImageUrl'
import { saveCommunityPublicity } from '@/api/community/addCommunityPublicityApi'
import { getCommunityId, getDict } from '@/api/community/communityApi'
import richTextEditor from '@/components/editor/RichTextEditor'
import DsPageHeader from '@/components/ds/ds-page-header.vue'

export default {
  name: 'AddCommunityPublicity',
  components: {
    UploadImageUrl,
    richTextEditor,
    DsPageHeader
  },
  data() {
    return {
      formData: {
        title: '',
        pubType: '',
        headerImg: '',
        context: ''
      },
      pubTypes: []
    }
  },
  created() {
    this.getPublicityTypes()
  },
  methods: {
    async getPublicityTypes() {
      try {
        const data = await getDict('community_publicity', 'pub_type')
        this.pubTypes = data
      } catch (error) {
        console.error('Failed to get publicity types:', error)
        this.$message.error(this.$t('addCommunityPublicity.fetchTypesFailed'))
      }
    },
    handleImageUpload(images) {
      if (images.length > 0) {
        this.formData.headerImg = images[0] || images[0]
      } else {
        this.formData.headerImg = ''
      }
    },
    submitForm() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.savePublicity()
        } else {
          return false
        }
      })
    },
    async savePublicity() {
      try {
        this.formData.communityId = getCommunityId()
        const response = await saveCommunityPublicity(this.formData)
        if (response.code === 0) {
          this.$message.success(this.$t('common.operationSuccess'))
          this.goBack()
        } else {
          this.$message.error(response.msg || this.$t('addCommunityPublicity.saveFailed'))
        }
      } catch (error) {
        console.error('Save publicity error:', error)
        this.$message.error(this.$t('addCommunityPublicity.saveFailed'))
      }
    },
    goBack() {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="scss" scoped>
.add-publicity-container {
  padding: var(--ds-spacing-lg);
  background-color: var(--ds-gray-100);
  min-height: calc(100vh - 60px);
}

/* 白色面板 */
.ds-panel {
  background: #fff;
  border: 1px solid var(--ds-gray-300);
  border-radius: var(--ds-radius-md);
  box-shadow: var(--ds-shadow-sm);
  padding: var(--ds-spacing-lg);
}

/* 表单 */
.ds-form {
  .el-form-item {
    margin-bottom: var(--ds-spacing-lg);
  }
}

/* 表单操作区 */
.ds-form-actions {
  display: flex;
  justify-content: flex-end;
  gap: var(--ds-spacing-sm);
  padding-top: var(--ds-spacing-md);
  border-top: 1px solid var(--ds-gray-200);
}
</style>
